export default __webpack_public_path__ + "static/media/hightlight2.b9a732e8.png";